<template>
    <div class="card p-1 mt-5">
      <div class="grid">

        <!-- Titulo Oficios -->
        <div class="col-9 xl:col-12 lg:col-12 md:col-12 sm:col-12 p-2  flex justify-content-start">
          <h5 class="p-2 mt-3 tablaTitle">
            <i class="fa-solid fa-file-contract fa-flip"
              style="--fa-animation-iteration-count: 1; --fa-animation-duration: 2.5s;"></i>
            <span class="px-2">
              Modificación de Folios
            </span>
          </h5>
        </div>
        <!-- Titulo Oficios -->


        <!-- Tabs -->
        <div class="col-8 mx-auto p-1 mb-8">
          <div class="">
            <div class="cardMenu col grid">
                <div class="col-6 ">
                    <div class="flex flex-column gap-2">
                        <label for="username">Último Número folio</label>
                        <InputTextV disabled id="username" v-model="valueUltimo" aria-describedby="username-help" />
                    </div>
                </div>
                <div class="col-6">
                    <div class="flex flex-column gap-2">
                        <label for="username">Nuevo Número folio</label>
                        <InputTextV id="username" @keypress="isNumber($event)" maxlength="5" v-model="value" aria-describedby="username-help" />
                    </div>
                </div>
                <div class="col-12 flex justify-content-center">
                    <div class="flex col-6 flex-column gap-2">
                        <ButtonVue @click="actualizarFolio" label="Actualizar" />
                    </div>
                </div>
                <!-- <div class="col-12"></div> -->
            </div>

          </div>
        </div>
        <!-- Tabs -->

      </div>
    </div>




  </template>
<script>
import { onMounted,  ref } from 'vue';
import api from "@/api/laravelApi";
import Swal from 'sweetalert2';

export default {
  setup() {
    const value = ref('');
    const valueUltimo = ref('');

    const cargarTodo = async () => {
      // Swal.showLoading()

      await api.get('folios/ultimoNumeroFolio').
      then(response => {
        valueUltimo.value = response.data.data.contador;
      })
      .catch(()=> {
        console.log('Error al cargar los datos');
      })
      .finally(() => {
        // Swal.showLoading(false)
      })
    }

    const actualizarFolio = async () => {
      if (value.value === '') {
        Swal.fire({
          title: 'Campo vacio',
          text: 'El número de folio no puede ir vacio',
          icon: 'error',
          confirmButtonText: 'Aceptar'
        })
      } else {

        Swal.showLoading()
        const body = {
          contador: value.value,
        }
        await api.post('folios/updateFolio', body).then(() => {
          Swal.hideLoading()
          Swal.fire({
            title: 'Actualización Exitosa',
            text: 'El número de folio ha sido actualizado',
            icon: 'success',
            confirmButtonText: 'Aceptar'
          })
        })
        .catch((error) => {
          const { data } = error.response;
          Swal.fire({
            title: 'Error',
            text: data.message.contador[0],
            icon: 'error',
            confirmButtonText: 'Aceptar'
          })
        })
        .finally(() => {
          cargarTodo()
            value.value = '';
              // Swal.close()
        })
      }
    }

    const isNumber = (evt) => {
        const keysAllowed= ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        const keyPressed= evt.key;

        if (!keysAllowed.includes(keyPressed)) {
              evt.preventDefault()
        }
    }

    onMounted(async () => {
      await cargarTodo();
    });

    return {
      value,
      valueUltimo,
      actualizarFolio,isNumber

    };

  }
}
</script>
